// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    // USER PROFILE-----------------------------------
    userProfile: path(ROOTS_DASHBOARD, '/users/profile'),
    userProfileEdit: path(ROOTS_DASHBOARD, '/users/profile/edit'),
    updateAdminPassword: path(ROOTS_DASHBOARD, '/users/profile/update-password'),

    // USERS -----------------------------------
    users: path(ROOTS_DASHBOARD, '/users'),
    addUser: path(ROOTS_DASHBOARD, '/users/add-user'),
    userEdit: (id) => path(ROOTS_DASHBOARD, `/users/${id}/edit`),
    userChargeHistory: (id) => path(ROOTS_DASHBOARD, `/users/${id}/charge-history`),

    // PROVIDER GROUPS-----------------------------------
    providerGroups: {
      list: path(ROOTS_DASHBOARD, '/provider-groups'),
      edit: (id) => path(ROOTS_DASHBOARD, `/provider-groups/${id}/edit`),
      add: path(ROOTS_DASHBOARD, '/provider-groups/new'),
    },

    // AGENTS -----------------------------------
    agents: path(ROOTS_DASHBOARD, '/agents'),
    addAgent: path(ROOTS_DASHBOARD, '/agents/add-agent'),
    agentEdit: (id) => path(ROOTS_DASHBOARD, `/agents/${id}/edit`),

    // CHARGERS -----------------------------------
    chargers: path(ROOTS_DASHBOARD, '/chargers'),
    chargersMap: path(ROOTS_DASHBOARD, '/chargers/map'),
    chargersList: path(ROOTS_DASHBOARD, '/chargers/list'),
    chargersWithoutLocationList: path(ROOTS_DASHBOARD, '/chargers/without-location-list'),
    chargersLogs: path(ROOTS_DASHBOARD, '/chargers/logs'),
    chargingSessions: path(ROOTS_DASHBOARD, '/chargers/charging-sessions'),
    chargerInfo: (id) => path(ROOTS_DASHBOARD, `/chargers/${id}/info`),
    chargerEdit: (id) => path(ROOTS_DASHBOARD, `/chargers/${id}/edit`),
    chargerLocationEdit: (id) => path(ROOTS_DASHBOARD, `/chargers/${id}/edit-location`),
    chargerGroups: {
      list: path(ROOTS_DASHBOARD, '/chargers/groups'),
      new: path(ROOTS_DASHBOARD, '/chargers/groups/new'),
      edit: (id) => path(ROOTS_DASHBOARD, `/chargers/groups/${id}/edit`),
    },

    // PROVIDERS -----------------------------------
    providers: path(ROOTS_DASHBOARD, '/providers'),
    addProvider: path(ROOTS_DASHBOARD, '/providers/add-provider'),
    providerEdit: (id) => path(ROOTS_DASHBOARD, `/providers/${id}/edit`),

    // VEHICLES -----------------------------------
    vehicles: path(ROOTS_DASHBOARD, '/vehicles-management/vehicles'),
    addVehicle: path(ROOTS_DASHBOARD, '/vehicles-management/vehicles/add-vehicle'),
    vehicleEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/vehicles/${id}/edit`),

    // MODELS -----------------------------------
    vehicleModel: path(ROOTS_DASHBOARD, '/vehicles-management/models'),
    addModel: path(ROOTS_DASHBOARD, '/vehicles-management/models/add-model'),
    modelEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/models/${id}/edit`),

    // OUTLETS -----------------------------------
    outletType: path(ROOTS_DASHBOARD, '/vehicles-management/outlet-types'),
    addOutletType: path(ROOTS_DASHBOARD, '/vehicles-management/outlet-types/add-outlet-type'),
    outletTypeEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/outlet-types/${id}/edit`),

    // BRANDS -----------------------------------
    vehicleBrand: path(ROOTS_DASHBOARD, '/vehicles-management/brands'),
    addBrand: path(ROOTS_DASHBOARD, '/vehicles-management/brands/add-brand'),
    brandEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/brands/${id}/edit`),

    // PAYMENTS -----------------------------------
    payments: path(ROOTS_DASHBOARD, '/payments/payments'),
    invoices: path(ROOTS_DASHBOARD, '/payments/invoices'),
    paymentLogs: path(ROOTS_DASHBOARD, '/payments/payment-logs'),
    chargingReport: path(ROOTS_DASHBOARD, '/payments/charging-report'),

    // Tariffs -----------------------------------
    tariffs: path(ROOTS_DASHBOARD, '/credits-management/tariffs'),
    addTariff: path(ROOTS_DASHBOARD, '/credits-management/tariffs/add-tariff'),
    tariffEdit: (id) => path(ROOTS_DASHBOARD, `/credits-management/tariffs/${id}/edit`),

    // Wallet -----------------------------------
    wallets: path(ROOTS_DASHBOARD, '/credits-management/wallets'),
    addWallet: path(ROOTS_DASHBOARD, '/credits-management/wallets/add-wallet'),
    walletEdit: (id) => path(ROOTS_DASHBOARD, `/credits-management/wallets/${id}/edit`),

    // CREDITS -------------------------------------
    credits: path(ROOTS_DASHBOARD, '/credits-management/credits'),
    balance: path(ROOTS_DASHBOARD, '/credits-management/balance'),
    addCredits: path(ROOTS_DASHBOARD, '/credits-management/credits/add-credits'),
    creditsEdit: (id) => path(ROOTS_DASHBOARD, `/credits-management/credits/${id}/edit`),

    // SETTINGS -----------------------------------
    settings: path(ROOTS_DASHBOARD, '/settings'),
    firmwares: path(ROOTS_DASHBOARD, '/settings/firmwares'),
    uploadFirmware: path(ROOTS_DASHBOARD, '/settings/firmwares/upload-firmware'),
    updateFirmware: path(ROOTS_DASHBOARD, '/settings/firmwares/update-firmware'),
    chargerSettings: path(ROOTS_DASHBOARD, '/settings/chargers'),
    networkSettings: path(ROOTS_DASHBOARD, '/settings/networks'),
    updateNetwork: path(ROOTS_DASHBOARD, '/settings/networks/update-network'),

    // AGENTS -----------------------------------
    agents: path(ROOTS_DASHBOARD, '/agents'),
    addAgent: path(ROOTS_DASHBOARD, '/agents/add-agent'),
    agentEdit: (id) => path(ROOTS_DASHBOARD, `/agents/${id}/edit`),

    // CHARGERS -----------------------------------
    chargers: path(ROOTS_DASHBOARD, '/chargers'),
    chargersMap: path(ROOTS_DASHBOARD, '/chargers/map'),
    chargersList: path(ROOTS_DASHBOARD, '/chargers/list'),
    chargersWithoutLocationList: path(ROOTS_DASHBOARD, '/chargers/without-location-list'),
    chargersLogs: path(ROOTS_DASHBOARD, '/chargers/logs'),
    chargingSessions: path(ROOTS_DASHBOARD, '/chargers/charging-sessions'),
    chargerInfo: (id) => path(ROOTS_DASHBOARD, `/chargers/${id}/info`),
    chargerEdit: (id) => path(ROOTS_DASHBOARD, `/chargers/${id}/edit`),
    chargerLocationEdit: (id) => path(ROOTS_DASHBOARD, `/chargers/${id}/edit-location`),
    chargerGroups: {
      list: path(ROOTS_DASHBOARD, '/chargers/groups'),
      new: path(ROOTS_DASHBOARD, '/chargers/groups/new'),
      edit: (id) => path(ROOTS_DASHBOARD, `/chargers/groups/${id}/edit`),
    },

    // OCPP CHARGERS -----------------------------------
    ocppChargers: path(ROOTS_DASHBOARD, '/ocpp-chargers'),
    ocppChargersList: path(ROOTS_DASHBOARD, '/ocpp-chargers/list'),
    ocppChargerAdd: path(ROOTS_DASHBOARD, '/ocpp-chargers/add-ocpp-charger'),
    ocppChargerEdit: (id) => path(ROOTS_DASHBOARD, `/ocpp-chargers/${id}/edit`),
    ocppchargersPictures: (id) => path(ROOTS_DASHBOARD, `/ocpp-chargers/${id}/charger-pictures`),
    sendComandsPage: (id) => path(ROOTS_DASHBOARD, `/ocpp-chargers/${id}/send-commands`),

    // PROVIDERS -----------------------------------
    providers: path(ROOTS_DASHBOARD, '/providers'),
    addProvider: path(ROOTS_DASHBOARD, '/providers/add-provider'),
    providerEdit: (id) => path(ROOTS_DASHBOARD, `/providers/${id}/edit`),

    // VEHICLES -----------------------------------
    vehicles: path(ROOTS_DASHBOARD, '/vehicles-management/vehicles'),
    addVehicle: path(ROOTS_DASHBOARD, '/vehicles-management/vehicles/add-vehicle'),
    vehicleEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/vehicles/${id}/edit`),

    // MODELS -----------------------------------
    vehicleModel: path(ROOTS_DASHBOARD, '/vehicles-management/models'),
    addModel: path(ROOTS_DASHBOARD, '/vehicles-management/models/add-model'),
    modelEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/models/${id}/edit`),

    // OUTLETS -----------------------------------
    outletType: path(ROOTS_DASHBOARD, '/vehicles-management/outlet-types'),
    addOutletType: path(ROOTS_DASHBOARD, '/vehicles-management/outlet-types/add-outlet-type'),
    outletTypeEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/outlet-types/${id}/edit`),

    // BRANDS -----------------------------------
    vehicleBrand: path(ROOTS_DASHBOARD, '/vehicles-management/brands'),
    addBrand: path(ROOTS_DASHBOARD, '/vehicles-management/brands/add-brand'),
    brandEdit: (id) => path(ROOTS_DASHBOARD, `/vehicles-management/brands/${id}/edit`),

    // PAYMENTS -----------------------------------
    payments: path(ROOTS_DASHBOARD, '/payments/payments'),
    invoices: path(ROOTS_DASHBOARD, '/payments/invoices'),
    paymentLogs: path(ROOTS_DASHBOARD, '/payments/payment-logs'),
    chargingReport: path(ROOTS_DASHBOARD, '/payments/charging-report'),

    // SETTINGS -----------------------------------
    settings: path(ROOTS_DASHBOARD, '/settings'),
    firmwares: path(ROOTS_DASHBOARD, '/settings/firmwares'),
    uploadFirmware: path(ROOTS_DASHBOARD, '/settings/firmwares/upload-firmware'),
    updateFirmware: path(ROOTS_DASHBOARD, '/settings/firmwares/update-firmware'),
    chargerSettings: path(ROOTS_DASHBOARD, '/settings/chargers'),
    networkSettings: path(ROOTS_DASHBOARD, '/settings/networks'),
    updateNetwork: path(ROOTS_DASHBOARD, '/settings/networks/update-network'),
    defineTaxes: path(ROOTS_DASHBOARD, '/settings/taxes/add'),
    listTaxes: path(ROOTS_DASHBOARD, '/settings/taxes/list'),
    updateTaxes: (id) => path(ROOTS_DASHBOARD, `/settings/taxes/${id}/update`),
    rfidTags: path(ROOTS_DASHBOARD, '/settings/rfid-tags/list'),
    chargingProfiles: path(ROOTS_DASHBOARD, '/settings/charging-profiles/list'),
    addChargingProfile: path(ROOTS_DASHBOARD, '/settings/charging-profiles/add'),
    editChargingProfile: (id) => path(ROOTS_DASHBOARD, `/settings/charging-profiles/${id}/edit`),
    addRfidTag: path(ROOTS_DASHBOARD, '/settings/rfid-tags/add'),
    rfidTagsEdit: (id) => path(ROOTS_DASHBOARD, `/settings/rfid-tags/${id}/edit`),
  },

  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
};
